import { createSelector } from '@ngrx/store';
import { IAppState } from '../../common/interfaces/app-state.interface';
import { IFinancialProfileStore } from '../interfaces/financial-profile-store.interface';

export const selectFinancialProfileStore = (state: IAppState) =>
  state.financialProfile;

export const selectInvoiceAmount = createSelector(
  selectFinancialProfileStore,
  (financialProfileStore: IFinancialProfileStore) => ({
    invoiceAmount: financialProfileStore.invoiceAmount,
  })
);

export const selectInvoiceTerm = createSelector(
  selectFinancialProfileStore,
  (financialProfileStore: IFinancialProfileStore) => ({
    invoiceTerm: financialProfileStore.invoiceTerm,
  })
);

export const selectBankStatementsComplete = createSelector(
  selectFinancialProfileStore,
  (financialProfileStore: IFinancialProfileStore) => ({
    bankStatementsComplete: financialProfileStore.bankStatementsComplete,
  })
);

export const selectBalanceSheetsComplete = createSelector(
  selectFinancialProfileStore,
  (financialProfileStore: IFinancialProfileStore) => ({
    balanceSheetsComplete: financialProfileStore.balanceSheetsComplete,
  })
);

export const selectPlStatementsComplete = createSelector(
  selectFinancialProfileStore,
  (financialProfileStore: IFinancialProfileStore) => ({
    plStatementsComplete: financialProfileStore.plStatementsComplete,
  })
);

export const selectArAgingComplete = createSelector(
  selectFinancialProfileStore,
  (financialProfileStore: IFinancialProfileStore) => ({
    arAgingComplete: financialProfileStore.arAgingComplete,
  })
);

export const selectApAgingComplete = createSelector(
  selectFinancialProfileStore,
  (financialProfileStore: IFinancialProfileStore) => ({
    apAgingComplete: financialProfileStore.apAgingComplete,
  })
);

export const selectAllFinancialProfile = createSelector(
  selectFinancialProfileStore,
  (financialProfileStore: IFinancialProfileStore) => ({
    invoiceAmount: financialProfileStore.invoiceAmount,
    invoiceTerm: financialProfileStore.invoiceTerm,
    bankStatementsComplete: financialProfileStore.bankStatementsComplete,
    balanceSheetsComplete: financialProfileStore.balanceSheetsComplete,
    plStatementsComplete: financialProfileStore.plStatementsComplete,
    arAgingComplete: financialProfileStore.arAgingComplete,
    apAgingComplete: financialProfileStore.apAgingComplete,
  })
);
